import { Modal } from '@unified-checkout/design-system';
import { useTranslation } from 'react-i18next';

type ClickPassKeySetupModalProps = {
  isOpen: boolean;
  onSubmit: () => void;
  onCancel: () => void;
};
export const ClickPassKeySetupModal = ({
  isOpen,
  onSubmit,
  onCancel,
}: ClickPassKeySetupModalProps) => {
  
  const { t } = useTranslation('kitComponents');
  
  return (
    <Modal
      width="25rem"
      open={isOpen}
      title={t('PASSKEY_MODAL_TITLE')}
      supportingText={t('PASSKEY_MODAL_SUBTITLE')}
      btnsProps={[
        {
          text: t('PASSKEY_MODAL_TITLE'),
          color: 'primary',
          onClickHandler: onSubmit,
        },
        {
          text: t('PASSKEY_MODAL_LATER_BTN'),
          color: 'secondary',
          variant: 'outlined',
          onClickHandler: onCancel,
        },
      ]}
    />
  );
};
